export default "__VITE_ASSET__CHVFv_oL__";